/**
 * Extracts the key (i.e., the filename and extension) from the URL
 * using the built-in URL class or with a simple string operation.
 * @param url
 */
export const extractS3Key = (imageUrl: string): string | null => {
  try {
    // Handle different S3 URL formats:
    // 1. https://bucket.s3.region.amazonaws.com/key (your format)
    // 2. https://s3.region.amazonaws.com/bucket/key
    // 3. https://bucket.s3.amazonaws.com/key (us-east-1)

    const url = new URL(imageUrl);

    // Format 1: bucket.s3.region.amazonaws.com/key (most common)
    if (
      url.hostname.includes('.s3.') &&
      url.hostname.includes('.amazonaws.com')
    ) {
      // Remove leading slash and return the path as the key
      // For your setup, this should be something like "uuid.jpg"
      const key = url.pathname.substring(1);
      return key;
    }

    // Format 2: s3.region.amazonaws.com/bucket/key
    if (
      url.hostname.startsWith('s3.') &&
      url.hostname.includes('.amazonaws.com')
    ) {
      // Remove the bucket name from the path
      const pathParts = url.pathname.substring(1).split('/');
      const key = pathParts.slice(1).join('/');
      return key;
    }

    console.error('Unrecognized S3 URL format:', imageUrl);
    return null;
  } catch (error) {
    console.error('Error parsing S3 URL:', error);
    return null;
  }
};
